export default __webpack_public_path__ + "static/media/dino_showroom_230vth.1ec84a13.jpg";